import { Amplify } from 'aws-amplify'
import Cognito, { getCurrentEnvironment } from './Configurations/cognito'
import getGraphQLConfig from './Configurations/graphql'
import { createApp } from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
import vuetify from './plugins/vuetify'
import { signOut } from 'aws-amplify/auth'

const details = Cognito()
const graphQL = getGraphQLConfig()

console.log(
  `[RCS Support] Environment: ${getCurrentEnvironment()} | host: ${window.location.hostname}`
)

try {
  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId: details.userPoolId,
        userPoolClientId: details.userPoolClientId,
        loginWith: {
          email: true,
        },
        signUpVerificationMethod: 'code',
      },
    },
    API: {
      GraphQL: {
        endpoint: graphQL.endpoint,
        region: graphQL.region,
        defaultAuthMode: 'userPool',
      },
    },
  })
} catch (error) {
  console.error('Amplify configuration error:', error)
}

const isTokenSessionError = (errorMessage = '') =>
  errorMessage.includes('NoValidAuthTokens') ||
  errorMessage.includes('No federated jwt')

const handleGlobalInvalidSession = async () => {
  if (router.currentRoute.value.path === '/') return
  try {
    await signOut()
  } catch (error) {
    console.error('Global sign out failed:', error)
  } finally {
    store.dispatch('logout')
    router.push('/')
  }
}

window.addEventListener('unhandledrejection', (event) => {
  const message = event?.reason?.message || ''
  if (isTokenSessionError(message)) {
    event.preventDefault()
    handleGlobalInvalidSession()
  }
})

createApp(App).use(store).use(router).use(vuetify).mount('#app')
